import { useEffect, useState } from "react";
import purchaseService from "../services/purchaseService";

/* eslint-disable react/prop-types */
export default function PromotionCodeBox({ cartItems, onApplied }) {
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [applied, setApplied] = useState(false);

    useEffect(() => {
        setApplied(false);
        onApplied(null);
    }, [cartItems, onApplied]);

    const handleApply = async () => {
        try {
            setLoading(true);

            const data = await purchaseService.previewPurchase({
                cartItems,
                promotionCode: code,
            });

            setApplied(true);
            onApplied({
                promotionCode: code.trim().toUpperCase(),
                finalTotal: data.finalTotal,
                discountPercentage: data.discountPercentage,
            });
        } catch (error) {
            setApplied(false);
            onApplied(null);
            window.alert(error.response?.data?.error || "Código inválido");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mx-auto mt-8 max-w-lg rounded-2xl border border-zinc-800 bg-zinc-900/80 p-4 shadow-[0_18px_40px_rgba(0,0,0,0.24)]">
            <label className="mb-2 block text-sm font-medium text-zinc-200">
                Código promocional
            </label>

            <div className="flex flex-col gap-2 sm:flex-row">
                <input
                    type="text"
                    value={code}
                    onChange={(e) => {
                        setCode(e.target.value.toUpperCase());
                        setApplied(false);
                        onApplied(null);
                    }}
                    placeholder="PROMO50"
                    className="w-full flex-1 rounded-xl border border-zinc-700 bg-zinc-950/70 px-3 py-2 text-zinc-100 outline-none transition focus:border-rose-400"
                />

                <button
                    type="button"
                    onClick={handleApply}
                    disabled={loading || !code || cartItems.length === 0}
                    className="rounded-xl bg-rose-600 px-4 py-2 font-semibold transition hover:bg-rose-500 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
                >
                    {loading ? "Validando..." : "Aplicar"}
                </button>
            </div>

            {applied && (
                <p className="mt-2 text-sm text-emerald-300">
                    Código aplicado correctamente.
                </p>
            )}
            {!applied && code && !loading && (
                <p className="mt-2 text-xs text-zinc-500">
                    Si el código es válido y hay stock, se aplicará al total.
                </p>
            )}
        </div>
    );
}
